<template>
<span class="text-md font-semibold inline-block py-1 px-2 uppercase rounded text-blue-600 bg-blue-200 uppercase last:mr-0 mr-1 count-box">
  制限時間:
    <span v-if="!isEnd">{{timerStr}}</span>
    <span style="color:red" v-else>時間切れ</span>
</span>

</template>

<script lang="ts">
  import { Component, Prop, Vue, Emit } from "vue-property-decorator";

  @Component
  export default class CountDown extends Vue {
    private goalDate: Date = new Date
    private timerStr: string = "　 　"
    private isEnd: boolean = false
    private interval: any = null

    start(goalMunite: number) {
      if (goalMunite == 0) return
      this.goalDate = new Date(+new Date() + (goalMunite * 60 * 1000));

      const vm = this
      this.setTimer()
      this.interval = setInterval(function () {
        const counter = vm.setTimer()

        if (counter[0] <= 0 && counter[1] <= 0) {
          clearInterval(vm.interval);
          vm.isEnd = true
        }
      }, 500);
    }

    stop() {
      clearInterval(this.interval);
    }

    countdown(due: Date) {
      var now = new Date();
      var rest = due.getTime() - now.getTime();
      this.countUp(Math.floor(rest / 1000))
      var sec = Math.floor(rest / 1000 % 60);
      var min = Math.floor(rest / 1000 / 60);
      var count = [min, sec];

      return count;
    }

    setTimer() {
      var counter = this.countdown(this.goalDate);
      let timerStr = ("0" + String(counter[0])).slice(-2) + ':' + ("0" + String(counter[1])).slice(-2);
      if (timerStr != "00:00") {
        this.timerStr = timerStr
      }
      return counter
    }

    @Emit('setCount')
    countUp(n: number) {
      return n;
    }
  }
</script>
<style scoped>
.count-box {
    font-size: 16px;
}
  @media screen and (max-width: 480px) {
    .count-box {
    font-size: 15px;
}
	.count-box span {
    font-size: 15px;
}
}
</style>
